<clr-modal
  id="loading-modal"
  [clrModalSize]="'md'"
  [clrModalOpen]="loadingService.Loading"
>
  <h3
    class="modal-title"
    *ngIf="loadingService?.messages[0]?.header; else default"
  >
    {{ loadingService.messages[0].header }}
  </h3>
  <ng-template #default>
    <h3 class="modal-title">Loading...</h3>
  </ng-template>
  <div class="modal-body">
    <p *ngFor="let message of loadingService.messages" class="mt-0 mb-4">
      {{ message['message'] }}
    </p>
    <span class="spinner spinner-lg"></span>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-link"
      *ngIf="loadingService.CancelButton"
      (click)="loadingService.cancelTask()"
    >
      Cancel
    </button>
  </div>
</clr-modal>
